import React, {Component} from 'react';
import $ from 'jquery';
import Data from '../data/contracts.json';
import {Link} from 'react-router-dom';
import Meta from '../model/Meta';

class Search extends Component {
    constructor(props){
        super(props);
        this.state = {
            search: this.props.match.params.search ? this.props.match.params.search : `All contracts`,
            data: Data
        }
    }
    componentWillMount() {
        //console.log(this.state);
    }

    componentDidMount() {
        $('html, body').animate({scrollTop: 0}, 300);
    }

    componentWillReceiveProps(nextProps) {
        //console.log(nextProps.match.params.search);
        this.setState({
            search: nextProps.match.params.search
        })
    }
    render() {
        let dataToArray = [];
        let realEstate = [...this.state.data.contracts[0].category["Real Estate"]];
        let freeContracts = [...this.state.data.contracts[1].category["Free Contracts"]];
        let business = [...this.state.data.contracts[2].category["Business"]];
        
        dataToArray.push(...realEstate);
        dataToArray.push(...freeContracts);
        dataToArray.push(...business);
        
        let filtered = [];
        let s = this.state.search.replace(/-/g, ' ');
        for (var i = 0; i < dataToArray.length; i++) {
            if (dataToArray[i].name.toLowerCase().search(s)>-1) {
                filtered.push(dataToArray[i]);
            }
        }

        if(s===`all contracts` || s===``) {
            filtered = dataToArray;
        }

        const meta = {
            title: "Search and create and customize fast and easy contracts",
            description: "Search our list of custom contracts"
        }

        return(
            <div className="page page-inner not-found pb-5">
                <Meta {...meta}/>
                <div className="container-fluid">
                    <div className="container p-0">
                        <h1 className="page-title">Search: "{this.state.search.replace(/-/g, ' ')}"</h1>
                        <div className="page-content">
                                <p>Found {filtered.length} contracts</p>
                                <div className="row">
                                    {
                                        filtered.map((obj, i)=>{
                                            return(
                                                <div className="col-sm-6 col-md-4" key={i}>    
                                                    <div className="card mb-3">
                                                        <div className="card-body">
                                                            <h5 className="card-title"><Link to={obj.url}>{obj.name}</Link></h5>
                                                            <p className="card-text">{obj.description.substring(0, 200)+`...`}</p>
                                                            <Link className="w-100 btn btn-lightblue" to={obj.url}>View</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                            
                                        })
                                    }
                                </div>

                                {
                                    filtered.length===0 ?
                                        <Link to="/contracts">Click here to view all contracts</Link> :
                                        ``
                                }

                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default Search;


// WEBPACK FOOTER //
// ./src/pages/Search.js